import { LICENSE_TYPES } from '@nesso/practice-contracts/practice-member.models';

// A state board can retire a license type a therapist already holds — see the permissive read
// schema in practice-member.queries.
const licenseTypeLabels: Record<string, string> = {
    LPC: 'LPC, Licensed Professional Counselor',
    LPCC: 'LPCC, Licensed Professional Clinical Counselor',
    LMHC: 'LMHC, Licensed Mental Health Counselor',
    LCPC: 'LCPC, Licensed Clinical Professional Counselor',
    LCSW: 'LCSW, Licensed Clinical Social Worker',
    LICSW: 'LICSW, Licensed Independent Clinical Social Worker',
    LMSW: 'LMSW, Licensed Master Social Worker',
    LSW: 'LSW, Licensed Social Worker',
    LMFT: 'LMFT, Licensed Marriage and Family Therapist',
    APCC: 'APCC, Associate Professional Clinical Counselor',
    AMFT: 'AMFT, Associate Marriage and Family Therapist',
    ASW: 'ASW, Associate Social Worker',
    'LPC-Associate': 'LPC-Associate, LPC Associate or Intern',
    'MFT-Intern': 'MFT-Intern, Marriage and Family Therapy Intern',
    LP: 'LP, Licensed Psychologist',
    HSP: 'HSP, Health Service Psychologist',
    LCP: 'LCP, Licensed Clinical Psychologist',
    CADC: 'CADC, Certified Alcohol and Drug Counselor',
    LCADC: 'LCADC, Licensed Clinical Alcohol and Drug Counselor',
    LADC: 'LADC, Licensed Alcohol and Drug Counselor',
    CAC: 'CAC, Certified Addiction Counselor',
    PMHNP: 'PMHNP, Psychiatric Mental Health Nurse Practitioner',
    PMHCNS: 'PMHCNS, Psychiatric Mental Health Clinical Nurse Specialist',
    BCBA: 'BCBA, Board Certified Behavior Analyst',
    BCaBA: 'BCaBA, Board Certified Assistant Behavior Analyst',
    QMHP: 'QMHP, Qualified Mental Health Professional',
};

export const licenseTypeOptions = LICENSE_TYPES.map((value) => ({
    value,
    label: licenseTypeLabels[value] ?? value,
}));

export function getLicenseTypeLabel(value: string): string {
    return licenseTypeLabels[value] ?? value;
}
